export const countries = {
  "GE-AB": "abkhazia",
  "AF, AFG, 004": "afghanistan",
  "AX, ALA, 248": "aland_islands",
  "AL, ALB, 008": "albania",
  "DZ, DZA, 012": "algeria",
  "AS, ASM, 016": "american_samoa",
  "AD, AND, 020": "andorra",
  "AO, AGO, 024": "angola",
  "AI, AIA, 660": "anguilla",
  "AG, ATG, 028": "antigua_and_barbuda",
  "AR, ARG, 032": "argentina",
  "AM, ARM, 051": "armenia",
  "AW, ABW, 533": "aruba",
  "AU, AUS, 036": "australia",
  "AT, AUT, 040": "austria",
  "AZ, AZE, 031": "azerbaijan",
  "PT-20": "azores_islands",
  "BS, BHS, 044": "bahamas",
  "BH, BHR, 048": "bahrain",
  "ES-IB": "balearic_islands",
  "BD, BGD, 050": "bangladesh",
  "BB, BRB, 052": "barbados",
  "ES-PV": "basque_country",
  "BY, BLR, 112": "belarus",
  "BE, BEL, 056": "belgium",
  "BZ, BLZ, 084": "belize",
  "BJ, BEN, 204": "benin",
  "BM, BMU, 060": "bermuda",
  "BT, BTN, 064": "bhutan",
  "BO, BOL, 068": "bolivia",
  "BQ, BES, 535": "bonaire",
  "BA, BIH, 070": "bosnia_and_herzegovina",
  "BW, BWA, 072": "botswana",
  "BR, BRA, 076": "brazil",
  "CA-BC": "british_columbia",
  "IO, IOT, 086": "british_indian_ocean_territory",
  "VG, VGB, 092": "british_virgin_islands",
  "BN, BRN, 096": "brunei",
  "BG, BGR, 100": "bulgaria",
  "BF, BFA, 854": "burkina_faso",
  "BI, BDI, 108": "burundi",
  "KH, KHM, 116": "cambodia",
  "CM, CMR, 120": "cameroon",
  "CA, CAN, 124": "canada",
  "ES-CN": "canary_islands",
  CV: "cape_verde",
  "KY, CYM, 136": "cayman_islands",
  "CF, CAF, 140": "central_african_republic",
  "ES-CE": "ceuta",
  "TD, TCD, 148": "chad",
  "CL, CHL, 152": "chile",
  "CN, CHN, 156": "china",
  "CX, CXR, 162": "christmas_island",
  "CC, CCK, 166": "cocos_island",
  "CO, COL, 170": "colombia",
  "KM, COM, 174": "comoros",
  "CK, COK, 184": "cook_islands",
  "FR-H": "corsica",
  "CR, CRI, 188": "costa_rica",
  "HR, HRV, 191": "croatia",
  "CU, CUB, 192": "cuba",
  "CW, CUW, 531": "curacao",
  "CZ, CZE, 203": "czech_republic",
  "CD, COD, 180": "democratic_republic_of_congo",
  "DK, DNK, 208": "denmark",
  "DJ, DJI, 262": "djibouti",
  "DM, DMA, 212": "dominica",
  "DO, DOM, 214": "dominican_republic",
  TL: "east_timor",
  "EC, ECU, 218": "ecuador",
  "EG, EGY, 818": "egypt",
  "SV, SLV, 222": "el_salvador",
  "GB-ENG": "england",
  "GQ, GNQ, 226": "equatorial_guinea",
  "ER, ERI, 232": "eritrea",
  "EE, EST, 233": "estonia",
  "ET, ETH, 231": "ethiopia",
  EU: "european_union",
  "FK, FLK, 238": "falkland_islands",
  "FJ, FJI, 242": "fiji",
  "FI, FIN, 246": "finland",
  "FR, FRA, 250": "france",
  "PF, PYF, 258": "french_polynesia",
  "GA, GAB, 266": "gabon",
  "EC-W": "galapagos_islands",
  "GM, GMB, 270": "gambia",
  "GE, GEO, 268": "georgia",
  "DE, DEU, 276": "germany",
  "GH, GHA, 288": "ghana",
  "GI, GIB, 292": "gibraltar",
  "GR, GRC, 300": "greece",
  "GL, GRL, 304": "greenland",
  "GD, GRD, 308": "grenada",
  "GU, GUM, 316": "guam",
  "GT, GTM, 320": "guatemala",
  "GG, GGY, 831": "guernsey",
  "GN, GIN, 324": "guinea",
  "GW, GNB, 624": "guinea_bissau",
  "HT, HTI, 332": "haiti",
  "US-HI": "hawaii",
  "HN, HND, 340": "honduras",
  "HK, HKG, 344": "hong_kong",
  "HU, HUN, 348": "hungary",
  "IS, ISL, 352": "iceland",
  "IN, IND, 356": "india",
  "ID, IDN, 360": "indonesia",
  "IR, IRN, 364": "iran",
  "IQ, IRQ, 368": "iraq",
  "IE, IRL, 372": "ireland",
  "IM, IMN, 833": "isle_of_man",
  "IL, ISR, 376": "israel",
  "IT, ITA, 380": "italy",
  CI: "ivory_coast",
  "JM, JAM, 388": "jamaica",
  "JP, JPN, 392": "japan",
  "JE, JEY, 832": "jersey",
  "JO, JOR, 400": "jordan",
  "KZ, KAZ, 398": "kazakhstan",
  "KE, KEN, 404": "kenya",
  "KI, KIR, 296": "kiribati",
  XK: "kosovo",
  "KW, KWT, 414": "kwait",
  "KG, KGZ, 417": "kyrgyzstan",
  "LA, LAO, 418": "laos",
  "LV, LVA, 428": "latvia",
  "LB, LBN, 422": "lebanon",
  "LS, LSO, 426": "lesotho",
  "LR, LBR, 430": "liberia",
  "LY, LBY, 434": "libya",
  "LI, LIE, 438": "liechtenstein",
  "LT, LTU, 440": "lithuania",
  "LU, LUX, 442": "luxembourg",
  "MO, MAC, 446": "macao",
  "MG, MDG, 450": "madagascar",
  "PT-30": "madeira",
  "MY, MYS, 458": "malasya",
  "MW, MWI, 454": "malawi",
  "MV, MDV, 462": "maldives",
  "ML, MLI, 466": "mali",
  "MT, MLT, 470": "malta",
  "MH, MHL, 584": "marshall_island",
  "MQ, MTQ, 474": "martinique",
  "MR, MRT, 478": "mauritania",
  "MU, MUS, 480": "mauritius",
  "ES-ML": "melilla",
  "MX, MEX, 484": "mexico",
  "FM, FSM, 583": "micronesia",
  "MD, MDA, 498": "moldova",
  "MC, MCO, 492": "monaco",
  "MN, MNG, 496": "mongolia",
  "ME, MNE, 499": "montenegro",
  "MS, MSR, 500": "montserrat",
  "MA, MAR, 504": "morocco",
  "MZ, MOZ, 508": "mozambique",
  "MM, MMR, 104": "myanmar",
  "NA, NAM, 516": "namibia",
  nato: "nato",
  "NR, NRU, 520": "nauru",
  "NP, NPL, 524": "nepal",
  "NL, NLD, 528": "netherlands",
  "NZ, NZL, 554": "new_zealand",
  "NI, NIC, 558": "nicaragua",
  "NE, NER, 562": "niger",
  "NG, NGA, 566": "nigeria",
  "NU, NIU, 570": "niue",
  "NF, NFK, 574": "norfolk_island",
  "KP, PRK, 408": "north_korea",
  northern_cyprus: "northern_cyprus", //NA
  "MP, MNP, 580": "northern_marianas_islands",
  "NO, NOR, 578": "norway",
  "OM, OMN, 512": "oman",
  ossetia: "ossetia", //NA
  "PK, PAK, 586": "pakistan",
  "PW, PLW, 585": "palau",
  "PS, PSE, 275": "palestine",
  "PA, PAN, 591": "panama",
  "PG, PNG, 598": "papua_new_guinea",
  "PY, PRY, 600": "paraguay",
  "PE, PER, 604": "peru",
  "PH, PHL, 608": "philippines",
  "PN, PCN, 612": "pitcairn_islands",
  "PL, POL, 616": "poland",
  "PT, PRT, 620": "portugal",
  "PR, PRI, 630": "puerto_rico",
  "QA, QAT, 634": "qatar",
  rapa_nui: "rapa_nui", //NA
  "MK, MKD, 807": "republic_of_macedonia",
  "CG, COG, 178": "republic_of_the_congo",
  "RO, ROU, 642": "romania",
  "RU, RUS, 643": "russia",
  "RW, RWA, 646": "rwanda",
  "BQ-SA": "saba_island",
  EH: "sahrawi_arab_democratic_republic",
  "KN, KNA, 659": "saint_kitts_and_nevis",
  "WS, WSM, 882": "samoa",
  "SM, SMR, 674": "san_marino",
  "ST, STP, 678": "sao_tome_and_prince",
  "IT-88": "sardinia",
  "SA, SAU, 682": "saudi_arabia",
  "GB-SCT": "scotland",
  "SN, SEN, 686": "senegal",
  "RS, SRB, 688": "serbia",
  "SC, SYC, 690": "seychelles",
  "IT-82": "sicily",
  "SL, SLE, 694": "sierra_leone",
  "SG, SGP, 702": "singapore",
  "BQ-SE": "sint_eustatius",
  "SX, SXM, 534": "sint_maarten",
  "SK, SVK, 703": "slovakia",
  "SI, SVN, 705": "slovenia",
  "SB, SLB, 090": "solomon_islands",
  "SO, SOM, 706": "somalia",
  somaliland: "somaliland", //NA
  "ZA, ZAF, 710": "south_africa",
  "KR, KOR, 410": "south_korea",
  "SS, SSD, 728": "south_sudan",
  "ES, ESP, 724": "spain",
  "LK, LKA, 144": "sri_lanka",
  "BL, BLM, FR-BL": "st_barts",
  LC: "st_lucia",
  "VC, VCT, 670": "st_vincent_and_the_grenadines",
  "SD, SDN, 729": "sudan",
  "SR, SUR, 740": "suriname",
  SZ: "swaziland",
  "SE, SWE, 752": "sweden",
  "CH, CHE, 756": "switzerland",
  "SY, SYR, 760": "syria",
  "TW, TWN, 158": "taiwan",
  "TJ, TJK, 762": "tajikistan",
  "TZ, TZA, 834": "tanzania",
  "TH, THA, 764": "thailand",
  "CN-XZ": "tibet",
  "TG, TGO, 768": "togo",
  "TK, TKL, 772": "tokelau",
  "TO, TON, 776": "tonga",
  transnistria: "transnistria", //NA
  "TT, TTO, 780": "trinidad_and_tobago",
  "TN, TUN, 788": "tunisia",
  "TR, TUR, 792": "turkey",
  "TM, TKM, 795": "turkmenistan",
  "TC, TCA, 796": "turks_and_caicos",
  "TV, TUV, 798": "tuvalu",
  "UG, UGA, 800": "uganda",
  "UA, UKR, 804": "ukraine",
  "AE, ARE, 784": "united_arab_emirates",
  "GB, GBR, 826": "united_kingdom",
  UN: "united_nations",
  "US, USA, 840": "united_states",
  "UY, URY, 858": "uruguay",
  "UZ, UZB, 860": "uzbekistn",
  "VU, VUT, 548": "vanuatu",
  VA: "vatican_city",
  "VE, VEN, 862": "venezuela",
  "VN, VNM, 704": "vietnam",
  "VI, VIR, 850": "virgin_islands",
  "GB-WLS": "wales",
  "YE, YEM, 887": "yemen",
  "ZM, ZMB, 894": "zambia",
  "ZW, ZWE, 716": "zimbabwe",
};

export const componentList = [
  { href: "#colors", title: "Colors" },
  { href: "#typography", title: "Typography" },
  { href: "#iconwrapper", title: "Icon Wrapper" },
  { href: "#accordion", title: "Accordion" },
  { href: "#alert", title: "Alert" },
  { href: "#artwork", title: "Artwork" },
  { href: "#autocomplete", title: "Auto Complete" },
  { href: "#avatar", title: "Avatar" },
  { href: "#badge", title: "Badge" },
  { href: "#banner", title: "Banner" },
  { href: "#breadcrumb", title: "Breadcrumb" },
  { href: "#button", title: "Button" },
  { href: "#card", title: "Card" },
  { href: "#calendar", title: "Calendar" },
  { href: "#checkbox", title: "Checkbox" },
  { href: "#comment", title: "Comment and Thread" },
  { href: "#datepicker", title: "Date Picker" },
  { href: "#divider", title: "Divider" },
  { href: "#dropdown", title: "Dropdown" },
  // { href: "#flag", title: "Flag" },
  { href: "#header", title: "Header" },
  { href: "#input", title: "Input" },
  { href: "#inputnumber", title: "Input Number" },
  { href: "#message", title: "Message" },
  { href: "#modal", title: "Modal" },
  { href: "#notification", title: "Notification" },
  { href: "#notes", title: "Notes" },
  { href: "#pagination", title: "Pagination" },
  { href: "#password", title: "Password" },
  { href: "#popconfirm", title: "PopConfirm" },
  { href: "#popover", title: "Popover" },
  { href: "#progress", title: "Progress" },
  { href: "#radio", title: "Radio" },
  { href: "#rating", title: "Rating" },
  { href: "#select", title: "Select" },
  { href: "#search", title: "Search" },
  { href: "#sidemenu", title: "Side Menu" },
  { href: "#skeleton", title: "Skeleton" },
  { href: "#slider", title: "Slider" },
  { href: "#spinner", title: "Spinner" },
  { href: "#stats", title: "Statistics" },
  { href: "#steps", title: "Steps" },
  { href: "#switch", title: "Switch" },
  { href: "#table", title: "Table" },
  { href: "#tags", title: "Tags" },
  { href: "#textarea", title: "Textarea" },
  { href: "#timepicker", title: "Timepicker" },
  { href: "#tooltip", title: "Tooltip" },
  { href: "#tree", title: "Tree" },
  { href: "#treeselect", title: "Tree Select" },
  { href: "#upload", title: "Upload" },
];
